var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"game-container"}},[(_vm.getGameLoading)?_c('loading'):_vm._e(),_c('game',{directives:[{name:"show",rawName:"v-show",value:(!_vm.getGameLoading),expression:"!getGameLoading"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }